'use strict';

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var explicitChildren = function explicitChildren(list) {
  return function (props, propName, componentName) {
    if (props.preventChildValidation === true) {
      return;
    }

    var childProp = props[propName];
    var wrongComponents = [];
    var hasFixedIndex = false;

    if (list.length === 1) {
      hasFixedIndex = true;
    }

    _react2['default'].Children.forEach(childProp, function (child, index) {
      var actualChild = child;
      var names = list[index];

      if (hasFixedIndex) {
        names = list[0];
      }

      if (!child) {
        return;
      }

      if (child.length) {
        actualChild = child[0];
      }

      var childName = actualChild.type.displayName || actualChild.type.name;

      if (childName) {
        var flag = false;
        names.forEach(function (name) {
          var isName = childName === name;
          var containsName = childName.indexOf(name) > -1;

          if (isName || containsName) {
            flag = true;
          }
        });

        if (!flag) {
          wrongComponents.push({
            is: actualChild.type.displayName,
            should: names
          });
        }
      }
    });

    if (wrongComponents.length) {
      var message = componentName + ': ';
      wrongComponents.forEach(function (_ref) {
        var is = _ref.is,
            should = _ref.should;
        message += is + ' did not contain ' + should.join(' or ') + '. ';
      });
      console.warn(message);
    }

    return;
  };
};

exports['default'] = explicitChildren;